var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuIconTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "telegram"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10151",
    "data-name": "Path 10151",
    d: "M89.494,61.2,70.983,76.328l-.871.713a.942.942,0,0,0-.348.614l-.195,1.609-.535,4.521a.208.208,0,1,1-.415.037L67.113,79.3l-1.555-4.625a.929.929,0,0,1,.448-1.1L85.267,62.533l3.625-2.074c.527-.307,1.066.357.6.738Z",
    transform: "translate(-38.34 -35.336)",
    fill: "#51aabc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10152",
    "data-name": "Path 10152",
    d: "M63.045,0H9.955A9.955,9.955,0,0,0,0,9.955V63.045A9.955,9.955,0,0,0,9.955,73H63.045A9.955,9.955,0,0,0,73,63.045V9.955A9.955,9.955,0,0,0,63.045,0ZM59.267,21.129,52.141,52.614a2.3,2.3,0,0,1-3.526,1.244l-10.759-7.3-5.479,5.181a1.883,1.883,0,0,1-3.036-.672L27.363,45.26l-1.978-5.807-10.606-2.9a1.377,1.377,0,0,1-.12-2.659L55.629,19.129l.755-.27a2.109,2.109,0,0,1,2.883,2.269Z",
    fill: "#51aabc"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconTelegram);
export default __webpack_public_path__ + "static/media/menu_icon_telegram.06e5ba18.svg";
export { ForwardRef as ReactComponent };